import { Link } from "react-router-dom";
import { ArrowUpRight } from "../../../components/svgs";

const TrainerCtaSection = () => {
  return (
    <section className="bg-primary py-16 md:py-20 px-4">
      <div className="container mx-auto flex flex-wrap items-center justify-between gap-10">
        <div className="max-w-2xl">
          <h2 className="text-white font-poppins font-black tracking-[-0.03em] leading-tight text-3xl md:text-4xl mb-5">
            Your experience could unlock someone else&apos;s future.
          </h2>
          <p className="text-indigo-100 font-poppins text-base leading-relaxed m-0">
            Apply to join the Utiva faculty network. Applications are reviewed
            against current programme and learner needs.
          </p>
        </div>

        <Link
          to="/be-a-trainer/get-started"
          className="bg-secondary text-primary font-poppins font-extrabold rounded-xl inline-flex items-center gap-3 px-6 py-4 custom-btn flex-none"
        >
          Start your application <ArrowUpRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    </section>
  );
};

export default TrainerCtaSection;
